import { SingleSelectChip } from '@/common/components/shared/single-select-chip/SingleSelectChip';
import { RehireRecommendation } from '@/common/graphql';
import { RehireRecommendationLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

interface RehireRecommendationSelectChipProps {
  value: RehireRecommendation | null;
  onChange: (value: RehireRecommendation | null) => void;
  disabled?: boolean;
  error?: string;
}

const sortOrder = [
  RehireRecommendation.StronglyRecommended,
  RehireRecommendation.Conditional,
  RehireRecommendation.NotRecommended,
];

const options = ObjectUtils.arrayFromEnumValues<RehireRecommendation>(RehireRecommendation).sort(
  (a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b),
);

export const RehireRecommendationSelectChip = (props: RehireRecommendationSelectChipProps) => (
  <SingleSelectChip
    {...props}
    items={options}
    label={option => RehireRecommendationLabels[option]}
    reactKey={option => option}
  />
);
